// extracted by mini-css-extract-plugin
module.exports = {"card":"Hero-module--card--BX6ZU","page":"Hero-module--page--ues7G","section":"Hero-module--section--rXWST"};